export default __webpack_public_path__ + "static/media/card-stock.9c530630.svg";